export default __webpack_public_path__ + "static/media/Frame.8125bb2d.svg";